<template>
  <section class="product-center">
    <div class="product-center__container">
      <h1 class="product-center__slogan">【美学设计 | 可佩戴的艺术品】</h1>
      <div class="product-center__visual">
        <img
          class="product-center__img"
          :src="productImgUrl"
          alt="PAXA 产品中心展示"
        />
      </div>
    </div>
  </section>
</template>

<script>
import productImg from '@/assets/product.png'

export default {
  name: 'ProductCenterPage',
  data() {
    return {
      /** 产品中心主图：src/assets/product.png */
      productImgUrl: productImg
    }
  },
  mounted() {
    console.info('[ProductCenterPage] 产品中心页已挂载，主图:', this.productImgUrl)
  }
}
</script>

<style scoped>
.product-center {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}

.product-center__container {
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  min-height: calc(100svh - var(--actionbar-inner-height, 72px));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(32px, 5vh, 72px) clamp(24px, 4vw, 64px)
    clamp(48px, 8vh, 120px);
  box-sizing: border-box;
}

.product-center__slogan {
  margin: 0 0 clamp(28px, 4vh, 56px);
  font-size: clamp(16px, 1.5vw, 20px);
  font-weight: 700;
  line-height: 1.45;
  color: #000;
  text-align: center;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.product-center__visual {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 0;
}

.product-center__img {
  width: auto;
  height: auto;
  max-width: min(100%, 920px);
  max-height: min(72vh, 640px);
  object-fit: contain;
  object-position: center;
  display: block;
}

@media (max-width: 640px) {
  .product-center__img {
    max-height: min(58vh, 520px);
  }
}
</style>
